export const formatCurrency = (
    value
) => {

    const amount =
        Number(
            value || 0
        );


    return new Intl.NumberFormat(
        "en-IN",
        {
            style:
                "currency",

            currency:
                "INR",

            maximumFractionDigits:
                0,
        }
    ).format(
        amount
    );
};


export const formatNumber = (
    value
) => {

    return new Intl.NumberFormat(
        "en-IN"
    ).format(
        Number(
            value || 0
        )
    );
};


export const formatPercentage = (
    value
) => {

    const percentage =
        Number(
            value || 0
        );


    return `${
        percentage > 0
            ? "+"
            : ""
    }${percentage.toFixed(1)}%`;
};


export const getGrowthType = (
    value
) => {

    const growth =
        Number(
            value || 0
        );


    if (
        growth > 0
    ) {
        return "positive";
    }


    if (
        growth < 0
    ) {
        return "negative";
    }


    return "neutral";
};


export const formatDashboardDate = (
    value
) => {

    if (!value) {
        return "-";
    }


    const date =
        new Date(
            value
        );


    if (
        Number.isNaN(
            date.getTime()
        )
    ) {
        return "-";
    }


    return date.toLocaleDateString(
        "en-IN",
        {
            day:
                "2-digit",

            month:
                "short",

            year:
                "numeric",
        }
    );
};


export const getPeriodLabel = (
    period
) => {

    const labels = {

        TODAY:
            "Today",

        YESTERDAY:
            "Yesterday",

        THIS_WEEK:
            "This Week",

        LAST_WEEK:
            "Last Week",

        THIS_MONTH:
            "This Month",

        LAST_MONTH:
            "Last Month",

        THIS_YEAR:
            "This Year",

        LAST_YEAR:
            "Last Year",

        THIS_FINANCIAL_YEAR:
            "Financial Year",

        CUSTOM:
            "Custom Range",
    };


    return (
        labels[
            period
        ] ||
        "Today"
    );
};